import { gql } from "@apollo/client";

export const SPECIALTIES = gql`
query getSpecialties {
  specialtiesForHome {
    en {
      title
      description
    }
    ar {
      title
      description
    }
  }
}
`

export const BOOKING_TIMES = gql`
query getBookingTimes {
  availableTimes {
    timeSlot {
      dayOfYear
      utcDate
    }
    booked
    contactType {
      name
    }
  }
}
`